import { useCallback, useMemo } from "react";
import { SLOT_PROPS } from "./TaskRunSelector.constants";
import type { TaskRunSelectorProps } from "./TaskRunSelector.types";
import { getTaskRunsDetails } from "./TaskRunSelector.utils";

export interface OptionsProps {
  minStartTime: number;
  totalDuration: number;
}

export const useTaskRunSelector = (props: Partial<TaskRunSelectorProps>) => {
  const { onChange: onChangeCallback, tasks } = props;

  const {
    minStartTime,
    totalDuration,
  }: { minStartTime: number; totalDuration: number } = useMemo(
    () => getTaskRunsDetails(tasks),
    [tasks]
  );

  const onChange = useCallback(
    (_e: any, value: any) => {
      onChangeCallback?.(value);
    },
    [onChangeCallback]
  );

  const slotProps = useMemo(
    () => ({
      ...SLOT_PROPS,
      ...props.slotProps,
    }),
    [props.slotProps]
  );

  return { minStartTime, totalDuration, onChange, slotProps };
};
